import apiClient from './apiClient';

export interface F938 {
  f938_01: number; f938_11: number; f938_12: number; f938_21: number;
}
export interface ListResponse { data: F938[]; total: number; page: number; size: number; }

export const pensionParamsApi = {
  async list(page = 1, size = 200): Promise<ListResponse> {
    return (await apiClient.get('/api/pension-params', { params: { page, size } })).data;
  },
  async get(id: number): Promise<F938> {
    return (await apiClient.get(`/api/pension-params/${id}`)).data;
  },
  async create(data: { f938_01: number; f938_12: number }): Promise<F938> {
    return (await apiClient.post('/api/pension-params', data)).data;
  },
  async update(id: number, data: { f938_12: number }): Promise<F938> {
    return (await apiClient.put(`/api/pension-params/${id}`, data)).data;
  },
  async delete(id: number): Promise<void> {
    await apiClient.delete(`/api/pension-params/${id}`);
  },
};
